// extracted by mini-css-extract-plugin
export default {"note":"YourIncome_note__rfI25","yourIncomeDisclaimer":"YourIncome_yourIncomeDisclaimer__W0Gur","skeletonLoadingAnimation":"YourIncome_skeletonLoadingAnimation__NnyVF"};